import token from "../../images/bigodToken.webp";
import { useGetVisitData, usePostVisit } from "../../api/dailyVisit/dailyvisit";
import { useEffect } from "react";

const VisitorCard = () => {
  const { data, isLoading ,isError } = useGetVisitData();
 

  const { mutate } = usePostVisit();
  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");
    if (!hasVisited) {
      mutate(
        {},
        {
          onSuccess: (response) => {
            sessionStorage.setItem("hasVisited", "true");
          },
          onError: (error) => {
            console.error("Visit tracking failed:", error);
          },
        }
      );
    }
  }, []);

  return (
    <div className="fixed bottom-4 right-4 bg-[#000] border-2 border-gray-600 text-white p-4 rounded-xl shadow-lg z-50 widget_mobile">
      <div className="flex gap-5 items-center">
        <img src={token} alt="" className="h-[40px]" />
        <div>
          <div className="flex gap-3">
            <h4 className="text-lg font-semibold">Daily Visits </h4>
            <span className="flex items-center gap-2">
              <span className="relative w-3 h-3">
                <span className="absolute top-0 left-0 w-3 h-3 bg-red-600 rounded-full animate-ping"></span>
                <span className="absolute top-0 left-0 w-3 h-3 bg-red-600 rounded-full"></span>
              </span>
              <span className="text-red-600 font-semibold text-xs">LIVE</span>
            </span>
          </div>

          <p className="text-lg font-bold text-[#00A2F9]">{isLoading? "Loading..." : data?.total}</p>
          {isError && <p className="text-lg font-bold text-[#00A2F9]">Loading...</p>}
        </div>
      </div>
    </div>
  );
};

export default VisitorCard;
